import { render, staticRenderFns } from "./ProductSelectHeaderPrice.vue?vue&type=template&id=6eb50805&scoped=true"
import script from "./ProductSelectHeaderPrice.vue?vue&type=script&lang=js"
export * from "./ProductSelectHeaderPrice.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectHeaderPrice.vue?vue&type=style&index=0&id=6eb50805&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb50805",
  null
  
)

export default component.exports